import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import { TransactionsStore } from '../../mobx-store/stores/transactionsStore';
import { Button, TextField, CircularProgress } from '@material-ui/core';
import classes from './transactions.module.scss';
import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import {
  WithSnackbarProps,
} from 'notistack';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  sapTransactions,
  TransactionStatus,
  TransactionFilterOptions,
  SapTransactionStatus,
  Transaction,
  PaymentType,
  TransactionDue,
} from '../../mobx-store/storeInterfaces/transactionInterface';
import moment from 'moment';
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import DatePickerField from 'components/GeneralCRUDComponent/FormFields/DatePickerField/DatePickerField';
import { translate } from 'helperFunctions/translation';
import AlertDialog from 'components/Dialog/alertDialog';
import { translations } from 'i18n-js';
import { AuthStore } from 'mobx-store/stores/authStore';
import { ROLES } from 'components/NavBar/NavigationItems/routes';

interface IProps extends WithSnackbarProps{
  history: any;
  transactionsStore: TransactionsStore;
  authStore: AuthStore;
  location: Location;
}

interface IState {
  transactionFilterOptions: TransactionFilterOptions;
  confirmationDialogOpen: boolean;
  selectedTransactionId: number;
}


@inject('transactionsStore')
@inject('authStore')
@observer
class TransactionsManagement extends Component<IProps, IState> {
  addButton: any;
  tableHeader: any = [];
  tableData: any[] = [];
  tableCellTypes: TableCellTypes[] = [];
  submitButton: any;
  cancelButton: any;
  statusFilterRef: SearchFilterDropdown;
  sapFilterRef: SearchFilterDropdown;
  paymentTypeFilterRef: SearchFilterDropdown;
  statusSearchFilterDropdown: any;
  sapSearchFilterDropdown: any;
  paymentTypeFilterDropdown: any;

  constructor(props: IProps) {
    super(props);
    this.state = {
      transactionFilterOptions: this.defaultTransactionFilterOptions,
      confirmationDialogOpen: false,
      selectedTransactionId: -1
    };
    this.handleAgree = this.handleAgree.bind(this);
  }

  get defaultTransactionFilterOptions(): TransactionFilterOptions {
    return {
      pageNumber: 1,
      totalNumberOfPages: 1,
      pageSize: 50,
      start: '',
      end: '',
      filterValue: '',
      status: TransactionStatus.ALL,
      isSapNotified: SapTransactionStatus.ALL,
      paymentType: PaymentType.ALL,
      payableFor: TransactionDue.Renewal,
    };
  }

  async componentWillMount () {
    this.props.transactionsStore.loading = true;
    await this.initTransactionsPage();
    this.props.transactionsStore.loading = false;
  }

  async initTransactionsPage() {
    await this.getQueryParams();
    await this.props.transactionsStore.getAllTransactions(this.state.transactionFilterOptions);
    this.setTotalPagesNumber(this.props.transactionsStore.transactionsCount);
  }

  getQueryParams() {
    const query = new URLSearchParams(this.props.location.search);
    this.setState({
      transactionFilterOptions: {
        start: query.get('start') || '',
        end: query.get('end') || '',
        filterValue: query.get('filterValue') || '',
        isSapNotified: query.get('isSapNotified') as SapTransactionStatus || SapTransactionStatus.ALL,
        pageNumber: Number(query.get('pageNumber')) || 1,
        pageSize: Number(query.get('pageSize')) || 50,
        status: query.get('status') as TransactionStatus || TransactionStatus.ALL,
        totalNumberOfPages: Number(query.get('totalNumberOfPages')) || 1,
        paymentType: query.get('paymentType') as PaymentType || PaymentType.ALL,
        payableFor: TransactionDue.Renewal,
      }
    }, () => {
      this.sapFilterRef.setState({
        status: this.state.transactionFilterOptions.isSapNotified as SapTransactionStatus,
      });
      this.statusFilterRef.setState({
        status: this.state.transactionFilterOptions.status,
      });
      this.paymentTypeFilterRef.setState({
        status: this.state.transactionFilterOptions.paymentType,
      });
    });
  }

  asyncSetState = async<K extends keyof IState>(state: Pick<IState, K>) => {
    return new Promise((res) => {
      this.setState({
        ...state,
      }, () => res());
    });
  };

  getStatisticsTableHeader = () => {
    const tableHeader = [
      {
        title: 'Transaction ID',
      },
      {
        title: 'Membership ID',
      },
      {
        title: 'Status',
      },
      {
        title: 'Amount',
      },
      {
        title: 'Fawary Status',
      },
      {
        title: 'Paymob Status',
      },
      {
        title: 'Points Status',
      },
      {
        title: 'SAP Status',
      },
      {
        title: 'Creation Date',
      },
      {
        title: 'Payment Date',
      },
      {
        title: 'Details',
      },
    ];
    if (this.props.authStore.userData.role.title === ROLES.SUPER_ADMIN) {
      tableHeader.push({
        title: "Cancel"
      });
    }
    return tableHeader;
  }

  getTransactionTableData = () => {
    const adllowedToCancel= this.props.authStore.userData.role.title === ROLES.SUPER_ADMIN;
    return this.props.transactionsStore.transactionsList
      .map((transaction: any) => {
        const transactionData: {[key: string]: any} = {
          transactionId: transaction.transactionId,
          status: transaction.status,
          amount: transaction.amount,
          fawaryTransactionStatus:
            transaction.fawryTransactions && transaction.fawryTransactions.length
              ? transaction.fawryTransactions[transaction.fawryTransactions.length -1].status
              : 'Not Found',
          paymobTransactionStatus:
            transaction.paymobTransactions && transaction.paymobTransactions.length
              ? transaction.paymobTransactions[transaction.paymobTransactions.length -1].status
              : 'Not Found',
          pointsTransactionStatus:
            transaction.deglawyPointsTransactions && transaction.deglawyPointsTransactions.length
              ? transaction.deglawyPointsTransactions[transaction.deglawyPointsTransactions.length -1].status
              : 'Not Found',
          SAPStatus: this.getNotifyButtonContent(transaction),
          membershipId: transaction.user.membershipId,
          createdAt: moment.utc(transaction.createdAt).format('YYYY-MM-DD'),
          date: moment.utc(transaction.paymentDate).format('YYYY-MM-DD'),
          details: 'details'
        };
        if(adllowedToCancel) {
          transactionData.cancel = 'cancel';
        }
        return transactionData;
      });
  }

  getNotifyButtonContent(transaction: Transaction) {
    if(this.props.transactionsStore.selectedNotifyingTransaction === transaction.transactionId) {
      return <CircularProgress color="inherit" size="1.7rem"/>
      ;
    } else {
      return this.isSapNotified(transaction) ? 'Re Notifiy': 'Notify'
    }
  }

  isSapNotified(transaction: any) {
    return transaction.sapTransactions.length && transaction.sapTransactions
      .every((transaction: sapTransactions) => transaction.isSapNotified);
  }
  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/transactions/renewals/${this.props.transactionsStore.transactionsList[index].transactionId}`);
  };
  cancelTransactionClicked = async (index: number, key: string) => {
    try {
      const transaction = this.props.transactionsStore!.transactionsList[index];
      this.props.transactionsStore.loading = true;
      if(transaction.transactionId) {
        await this.props.transactionsStore.updateTransactionStatus(
          transaction.transactionId,
          TransactionStatus.CANCELED
        );
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      }
      this.initTransactionsPage();
      this.props.transactionsStore.loading = true;
    } catch (error) {
      const errMessage: string = error?.message || translate('errorMessage', {});
      SnackBarComponent.getInstance().openSnackbar(errMessage, 8000, 'error');
    }
  };
  notifySapTransactions = async (index: number , key: string) => {
    const transaction = this.props.transactionsStore.transactionsList[index];
    if(transaction.status === TransactionStatus.SUCCEEDED) {
        this.setState({
          confirmationDialogOpen: true,
          selectedTransactionId: transaction.transactionId as number,
        });
    } else {
      this.notifySapTransactionById(transaction.transactionId as number);
    }
  };

  async notifySapTransactionById(transactionId: number) {
    try {
      this.props.transactionsStore.selectedNotifyingTransaction = transactionId;
      await this.props.transactionsStore.notifySapTransactions(transactionId);
      await this.initTransactionsPage();
      this.props.transactionsStore.selectedNotifyingTransaction = null;
      SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
    }), 8000, 'success');
    } catch (error) {
      // Case of transactions status set from successed to processing and transactions faild
      // then init the page with latest changes
      await this.initTransactionsPage();
      this.props.transactionsStore.selectedNotifyingTransaction = null;
      const errMessage: string = error?.message || translate('errorMessage', {});
      SnackBarComponent.getInstance().openSnackbar(errMessage, 8000, 'error');
    }
  }
  async handleAgree() {
    this.notifySapTransactionById(this.state.selectedTransactionId);
    this.setState({
      confirmationDialogOpen: false,
      selectedTransactionId: -1
    });
  }

  getStatisticsTableCellTypes = (): TableCellTypes[] =>  {
    let cellTypes: TableCellTypes [] = [
      {
        cellType: 'Text',
        key: 'transactionId',
      },
      {
        cellType: 'Text',
        key: 'membershipId',
      },
      {
        cellType: 'Text',
        key: 'status',
      },
      {
        cellType: 'Text',
        key: 'amount',
      },
      {
        cellType: 'Text',
        key: 'fawaryTransactionStatus',
      },
      {
        cellType: 'Text',
        key: 'paymobTransactionStatus',
      },
      {
        cellType: 'Text',
        key: 'pointsTransactionStatus',
      },
      {
        cellType: 'Button',
        key: 'SAPStatus',
        onClick: this.notifySapTransactions,
        disabled: this.disableStatus,
      },
      {
        cellType: 'Text',
        key: 'createdAt',
      },
      {
        cellType: 'Text',
        key: 'date',
      },
      {
        cellType: 'Button',
        key: 'details',
        onClick: this.handleTableButtonCellClicked,
      }
    ];
    if(this.props.authStore.userData.role.title === ROLES.SUPER_ADMIN) {
      cellTypes.push({
        cellType: 'Button',
        key: 'cancel',
        onClick: this.cancelTransactionClicked,
        disabled: this.disableCancelButton
      })
    }
    return cellTypes;
  }
  disableCancelButton = (index: number) => {
    const status = this.props.transactionsStore!.transactionsList[index].status as TransactionStatus;
    return [TransactionStatus.SUCCEEDED, TransactionStatus.CANCELED].includes(status);
  }
  disableStatus = (index: number) => {
    const transaction = this.props.transactionsStore!.transactionsList[index];
    // const isSapNotified = this.isSapNotified(transaction);
    return (transaction.status !== TransactionStatus.SUCCEEDED && 
    transaction.status !== TransactionStatus.PROCCESSING) ||
    new Date(transaction.createdAt as Date) <= new Date("2020-5-1");
  };

  leftArrowClicked = async () => {
    this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        pageNumber: this.state.transactionFilterOptions.pageNumber - 1
      }
    }), () => {
      this.searchTransactions();
    });
  }  

  rightArrowClicked = async () => {
    this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        pageNumber: this.state.transactionFilterOptions.pageNumber + 1
      }
    }), () => {
      this.searchTransactions();
    });
  }
  setTotalPagesNumber = async (totalNumber: number) => {
    const numberOfPages = Math.ceil(
      totalNumber / this.state.transactionFilterOptions.pageSize,
    );
    await this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        totalNumberOfPages: numberOfPages
      }
    }));
  };

  handleSearchChanged = async (filterValue: string) => {
    await this.setState((prevState: IState) =>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        // pageNumber: 1,
        filterValue
      },
    }));
  };
  searchTransactions = async () => {
    await this.getTransaction();
  };

  download = async () => {
    await this.props.transactionsStore.download(this.state.transactionFilterOptions);
  };

  handleStartDateChanged = (startDate: Date) => {
    this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        start: this.formateDate(startDate),
      }
    }));

  };
  handleEndDateChanged = (endDate: Date) => {
    this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        end: this.formateDate(endDate),
      }
    }));
  };

  filter = async () => {
    this.setState((prevState: IState) => ({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        pageNumber: 1,
      },
    }), async () => {
      const {
        transactionFilterOptions,
      } = this.state;

      const {
        history,

      } = this.props;

      history.push({
        pathname: '/transactions/renewals',
        search: `&filterValue=${transactionFilterOptions.filterValue}`
        + `&start=${transactionFilterOptions.start}`
        + `&end=${transactionFilterOptions.end}`
        + `&status=${transactionFilterOptions.status}`
        + `&isSapNotified=${transactionFilterOptions.isSapNotified}`
        + `&paymentType=${transactionFilterOptions.paymentType}`,
      });
      await this.getTransaction();
    });
  };

  formateDate(date: Date){
    if(!date) return '';
    date = new Date(date);
    const foratedDate = `${((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()}`
    return foratedDate;
  }

  handleClearFilter = async () => {
    this.props.history.push({
      pathname: '/transactions/renewals',
      search: '',
    });
    this.statusFilterRef.setState({
      status: TransactionStatus.ALL,
    });
    this.sapFilterRef.setState({
      status: SapTransactionStatus.ALL,
    });
    this.paymentTypeFilterRef.setState({
      status: PaymentType.ALL,
    });
    this.setState({
      transactionFilterOptions: this.defaultTransactionFilterOptions
    }, () => {
      this.getTransaction();
    });
  };
  
  getTransaction = async() =>{
    this.props.transactionsStore.loading = true;
    await this.props.transactionsStore.getAllTransactions(this.state.transactionFilterOptions);
    this.props.transactionsStore.loading = false;
    this.setTotalPagesNumber(this.props.transactionsStore.transactionsCount);
  }
  
  selectStatusSearchChange(newFilter: any) {
    this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        status: newFilter,
      }
    }));
  }
  selectSapStatusSearchChange(newFilter: any) {
    this.setState((prevState: IState)=>({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        isSapNotified: newFilter,
      }
    }));
  }

  selectPaymentTypeSearchChange(newFilter: PaymentType) {
    this.setState((prevState: IState) => ({
      transactionFilterOptions: {
        ...prevState.transactionFilterOptions,
        paymentType: newFilter,
      },
    }));
  }

  getTransactionsStatus = () => ({
    value: `${this.state.transactionFilterOptions.status}`,
    onChange: this.selectStatusSearchChange.bind(this),
    filters: [
      ...Object.values(TransactionStatus).map((status) =>{
        return {
          value: status,
          name: status
        }
      })
    ]

  });

  getSapTransactionsOptions = () => ({
    value: 'all',
    onChange: this.selectSapStatusSearchChange.bind(this),
    filters: [
      {
        value: 'all',
        name: 'all'
      },
      {
        value: true,
        name: 'true'
      },
      {
        value: false,
        name: 'false'
      }
    ]
  });

  getPaymentTypeOptions = () => ({
    value: 'all',
    onChange: this.selectPaymentTypeSearchChange.bind(this),
    filters: [
      {
        value: 'all',
        name: 'All',
      },
      {
        value: 'fawry',
        name: 'Fawry',
      },
      {
        value: 'paymob',
        name: 'Paymob',
      },
      {
        value: 'points',
        name: 'Points',
      },
    ],
  });

  render() {
    this.tableHeader = this.getStatisticsTableHeader();
    this.tableData = this.getTransactionTableData();
    this.tableCellTypes = this.getStatisticsTableCellTypes();
    this.statusSearchFilterDropdown = this.getTransactionsStatus();
    this.sapSearchFilterDropdown = this.getSapTransactionsOptions();
    this.paymentTypeFilterDropdown = this.getPaymentTypeOptions();

    return (
          <div>
            <TextField
              className={classes.input}
              placeholder={'Search'}
              value={this.state.transactionFilterOptions.filterValue}
              label={'Search'}
              onKeyPress={(e) => {
                if(e.key === 'Enter') {
                  this.filter();
                }
              }}
              onChange={(text) => {
                this.handleSearchChanged(text.target.value);
              }}
            />
            <br></br>
            <div>
            <div className={classes.inputGroup}>
             <div className={classes.dateGroup}>
              <DatePicker
                  variant="inline"
                  className={classes.datePicker}
                  label="Search By Date From"
                  name="startdatasearch"
                  format="dd/MM/yyyy"
                  value={this.state.transactionFilterOptions.start || null}
                  views={['year', 'month', 'date']}
                  onChange={(value) => {
                    this.handleStartDateChanged(value as any || new Date() as any);
                  }}
                />
                <DatePicker
                  variant="inline"
                  className={classes.datePicker}
                  label="To"
                  name="enddatasearch"
                  format="dd/MM/yyyy"
                  value={this.state.transactionFilterOptions.end || null}
                  views={['year', 'month', 'date']}
                  onChange={(value) => {
                    this.handleEndDateChanged(value as any || new Date() as any);
                  }}
                />
             </div>
              <SearchFilterDropdown 
                ref={(ref) => {
                  if(ref) this.statusFilterRef = ref
                }}           
                label="Status" 
                searchFilterDropdown={this.statusSearchFilterDropdown} 
              />
               <SearchFilterDropdown 
                ref={(ref) => {
                  if(ref) this.sapFilterRef = ref
                }}           
                label="Sap Notified" 
                searchFilterDropdown={this.sapSearchFilterDropdown} 
              />

              <SearchFilterDropdown
                ref={(ref) => {
                  if (ref) this.paymentTypeFilterRef = ref;
                }}
                label="Payment Type"
                searchFilterDropdown={this.paymentTypeFilterDropdown}
              />
            </div>
              <div className={classes.filterButton}>
              <Button 
              onClick={this.filter} 
              color="primary"
              variant="contained">
                Filter 
              </Button>
              <Button 
              onClick={this.handleClearFilter} 
              color="primary"
              variant="contained">
                Clear 
              </Button>
              </div>
            </div>
            
            <br></br>
            <div>
            <div className={classes.download}>
            <Button 
            onClick={this.download} 
            color="primary"
            variant="contained">
              Download 
            </Button>
            </div>
            <p>*You can notify the sap with only processing transaction which made after 1/5/2020 </p>
            <AlertDialog
              title={translate(`TRANSACTIONS_RE_NOTIFY_DIALOG_TITLE`, {
              })}
              content={translate('TRANSACTIONS_RE_NOTIFY_DIALOG_CONTENT', {
              })}
              isOpen={this.state.confirmationDialogOpen}
              agree={this.handleAgree}
              disAgree={() => this.setState({confirmationDialogOpen: false})}
              hasActions
            />
            <GeneralTableComponent 
              emptyMessage={'emptyMessage'}
              tableHeader={this.tableHeader}
              tableData={this.tableData}
              tableCellTypes={this.tableCellTypes}
              loading = { this.props.transactionsStore!.loading}
              hadPagination={true}
              paginationAction={{
                  handleClickLeftArrow: this.leftArrowClicked,
                  handleClickRightArrow: this.rightArrowClicked,
                  pageNumber: this.state.transactionFilterOptions.pageNumber,
                  totalNumberOfPages: this.state.transactionFilterOptions.totalNumberOfPages,
              }}
            />
            </div>
          </div>
        );
    }
}

export default TransactionsManagement;
